import React from 'react';
import './InputField.css';

const TextAreaInputField = (props) => {
    return(
        <div className={'text-input-wrapper'}>
            <div>
                <div className={'text-input-label'}>{props.label}</div>
            </div>
            <textarea rows={props.rows} placeholder={props.placeholder} style={{resize:'none'}} name={props.name} className="text-input-field" value={props.value} onChange={props.onChange} type="text"/>
        </div>
    )
}

export default TextAreaInputField;